module.exports = __webpack_public_path__ + "img/logo3.3a49e15f.jpg";